import React, { useState } from "react";
import Layout from "../../hoc/Layout";
import { Input, Button, Dimmer, Loader } from "semantic-ui-react";

import { toast } from "react-toastify";
import { auth } from "../../firebase";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    await auth.currentUser
      .updatePassword(password)
      .then(() => {
        setPassword("");
        setLoading(false);
        toast.success("Password updated");
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        toast.error(err.message);
      });
  };

  const forgotForm = () => (
    <form onSubmit={handleSubmit} className="mainForm">
      <Input
        type="password"
        placeholder="Enter new password"
        className="regInput"
        value={password}
        autoFocus
        disabled={loading}
        onChange={(e) => setPassword(e.target.value)}
      />
      <Button
        type="submit"
        basic
        color="purple"
        disabled={!password || password.length < 6 || loading}
      >
        Send Reset request
      </Button>
    </form>
  );

  return (
    <Layout>
      <div className="createImage"></div>
      <div className="home">
        <div className="ui container ">
          <div className="regForm">
            {loading ? (
              <>
                {" "}
                <Dimmer active inverted>
                  <Loader size="massive">Loading</Loader>
                </Dimmer>
              </>
            ) : (
              <>
                <h2 className="subTitle">Reset Password</h2>
                {forgotForm()}
              </>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ResetPassword;
